{
  "header": {
    "eyebrow": "Laadnetwerk",
    "title": "CPO-analyse",
    "description": "Vlootoverzicht van je laadstations: beschikbaarheid, socketstatus en storingen over alle locaties.",
    "action": "Open EVinity-dashboard"
  },
  "aside": {
    "aria": "Socketstatus-overzicht"
  },
  "kpi": {
    "operative": {
      "label": "Operationele apparaten",
      "description": "Stations die nu beschikbaar zijn"
    },
    "chargingSockets": {
      "label": "Ladende sockets",
      "description": "Sockets die nu actief laden"
    },
    "faultedSockets": {
      "label": "Sockets met storing",
      "description": "Sockets die een storing melden"
    },
    "devicesOffline": {
      "label": "Apparaten offline",
      "description": "Stations niet bereikbaar"
    }
  },
  "map": {
    "title": "Locaties",
    "error": "Kon locatiegegevens niet laden - de kaart is mogelijk onvolledig.",
    "stationCount": "{{count}} station",
    "stationCount_other": "{{count}} stations",
    "filter": {
      "all": "Alle ({{count}})",
      "critical": "Offline ({{count}})",
      "warning": "Storing ({{count}})",
      "healthy": "Gezond ({{count}})"
    }
  },
  "socketStatus": {
    "title": "Huidige socketstatus",
    "available": "Beschikbaar",
    "occupied": "Bezet",
    "reserved": "Gereserveerd",
    "inoperative": "Buiten gebruik",
    "faulted": "Storing",
    "unknown": "Onbekend"
  },
  "socketSubStatus": {
    "title": "Detail bezette sockets",
    "preparing": "Voorbereiden",
    "charging": "Laden",
    "suspended_ev": "Onderbroken (EV)",
    "suspended_evse": "Onderbroken (EVSE)",
    "finishing": "Afronden"
  },
  "status": {
    "available": "Beschikbaar",
    "occupied": "Bezet",
    "reserved": "Gereserveerd",
    "inoperative": "Buiten gebruik",
    "faulted": "Storing",
    "offline": "Offline",
    "unknown": "Onbekend"
  },
  "list": {
    "title": "Laadstations",
    "count": "{{visible}} van {{total}}",
    "sockets": "{{count}} socket",
    "sockets_other": "{{count}} sockets",
    "searchPlaceholder": "Zoek op ID, locatie of model",
    "searchAria": "Zoek laadstations",
    "openSelected": "Open selectie ({{count}})",
    "selectAllAria": "Selecteer alle laadstations",
    "selectRowAria": "Selecteer {{id}}",
    "filters": {
      "aria": "Filter stations",
      "status": "Status",
      "location": "Locatie",
      "locationAria": "Filter op locatie",
      "allLocations": "Alle locaties"
    },
    "columns": {
      "station": "Station",
      "location": "Locatie",
      "status": "Status",
      "model": "Model",
      "power": "Max. vermogen",
      "lastSeen": "Laatst gezien",
      "actions": "Acties"
    },
    "openInCpms": "{{id}} openen in CPMS",
    "lastSeen": {
      "never": "Nooit",
      "justNow": "Zojuist",
      "minutes": "{{count}} min geleden",
      "hours": "{{count}} u geleden",
      "days": "{{count}} d geleden"
    },
    "empty": {
      "title": "Geen laadstations",
      "description": "Geen stations komen overeen met de huidige filters."
    }
  },
  "faulted": {
    "title": "Sockets met storing",
    "count": "{{count}} met storing",
    "columns": {
      "station": "Station",
      "socket": "Socket",
      "error": "Fout",
      "actions": "Acties"
    },
    "openInCpms": "{{id}} openen in CPMS",
    "empty": {
      "title": "Geen storingen",
      "description": "Alle sockets werken normaal."
    }
  },
  "error": {
    "title": "Vlootgegevens laden mislukt",
    "description": "Het laadstationbeheersysteem is niet bereikbaar. Probeer het later opnieuw."
  },
  "fleetTransactions": {
    "title": "Lopende transacties",
    "ongoing": "Lopende transacties",
    "suspendedEvse": "Onderbroken (EVSE)",
    "count": "{{count}} lopend",
    "searchPlaceholder": "Zoek op tag of station",
    "searchAria": "Zoek lopende transacties",
    "columns": {
      "location": "Locatie",
      "socket": "Socket",
      "subStatus": "Substatus",
      "power": "Max. vermogen",
      "started": "Gestart",
      "charged": "Geladen"
    },
    "empty": { "title": "Geen lopende transacties" },
    "error": {
      "title": "Lopende transacties laden mislukt",
      "description": "Het laadstationbeheersysteem is niet bereikbaar. Probeer het later opnieuw."
    }
  },
  "combined": {
    "title": "Gecombineerde analyse",
    "count": "{{count}} laadstation",
    "count_other": "{{count}} laadstations",
    "sectionTitle": "Geselecteerde laadstations",
    "stationsTitle": "Laadstations",
    "stationsCount": "{{count}} geselecteerd",
    "notFound": {
      "title": "Stations niet gevonden",
      "description": "Geen van de geselecteerde laadstations kon worden gevonden."
    }
  },
  "detail": {
    "eyebrow": "Laadstation",
    "noLocation": "Geen locatie",
    "rangeAria": "Periode",
    "tabs": { "financial": "Financieel", "technical": "Technisch", "transactions": "Transacties" },
    "range": { "7": "7 dagen", "30": "30 dagen", "180": "180 dagen" },
    "notFound": {
      "title": "Station niet gevonden",
      "description": "Geen laadstation komt overeen met \"{{id}}\".",
      "back": "Terug naar vloot"
    },
    "noData": { "title": "Geen gegevens", "description": "Geen gegevens voor de gekozen periode." },
    "info": {
      "title": "Laadstationdetails",
      "deviceDetails": "Apparaatdetails",
      "address": "Adres",
      "customName": "Aangepaste naam",
      "manufacturer": "Fabrikant",
      "model": "Model",
      "locationStatus": "Locatie & status",
      "location": "Locatie",
      "status": "Status",
      "lastSeen": "Laatst gezien",
      "availability": "Beschikbaarheid",
      "maxPower": "Max. vermogen",
      "mapTitle": "Locatie"
    },
    "kpi": {
      "transactions": "Transacties",
      "kwh": "kWh geladen",
      "uptime": "Uptime",
      "co2": "CO₂ bespaard"
    },
    "income": { "title": "Totale inkomsten", "series": "Inkomsten", "total": "Totaal" },
    "txTimeline": {
      "title": "Transacties in de tijd",
      "series": "Transacties",
      "avg": "Gem./dag",
      "max": "Max/dag"
    },
    "uniqueUsers": {
      "title": "Unieke gebruikers",
      "series": "Gebruikers",
      "count": "Gebruikers",
      "perUser": "Sessies/gebruiker"
    },
    "paymentMethod": {
      "title": "Betaalmethode",
      "qr": "QR-code",
      "app": "Mobiele app",
      "local": "Lokale autorisatie"
    },
    "txStatus": { "title": "Transactiestatus", "successful": "Geslaagd", "error": "Fout" },
    "duration": { "title": "Laadduur", "short": "< 1u", "medium": "1–4u", "long": "4u+" },
    "consumptionTime": { "title": "Tijdstip", "day": "Dag (08–20u)", "night": "Nacht (20–08u)" },
    "average": {
      "title": "Gemiddelde transactie",
      "income": "Inkomsten",
      "duration": "Duur",
      "consumption": "Verbruik",
      "distributionTitle": "Verdeling transactiewaarde",
      "lt5": "< €5",
      "b5_10": "€5–10",
      "b10_15": "€10–15",
      "b15_20": "€15–20",
      "gte20": "> €20"
    },
    "incomeBreakdown": {
      "title": "Inkomsten uitgesplitst",
      "energy": "Energie",
      "time": "Laadtijd",
      "parking": "Parkeertijd",
      "flat": "Vast tarief"
    },
    "technical": {
      "available": "Beschikbaar",
      "faulted": "Storing",
      "inoperative": "Buiten gebruik",
      "offline": "Offline",
      "unknown": "Onbekend",
      "availablePerDay": "Beschikbare uren/dag",
      "availableSeries": "Beschikbare uren",
      "durations": "Tijd per status"
    },
    "transactions": {
      "title": "Transacties",
      "count": "{{count}} transacties",
      "active": "Actief",
      "completed": "Voltooid",
      "columns": {
        "started": "Gestart",
        "socket": "Socket",
        "energy": "Energie",
        "duration": "Duur",
        "status": "Status"
      },
      "empty": { "title": "Geen transacties" }
    }
  }
}
